import { getFirebaseAuthToken } from './firebaseAuthToken';

export const getFirebaseUploadAuthHeaders = async (currentUser) => {
  const token = await getFirebaseAuthToken(currentUser);
  return {
    Authorization: `Bearer ${token}`,
  };
};
